import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';

@Component({
  selector: 'acl-device-delete',
  standalone: false,
  templateUrl: './device-delete.component.html',
  styleUrl: './device-delete.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceDeleteComponent {
  // New Signal Inputs
  // Using input<type>() makes these read-only signals
  readonly message = input<string>('');
  readonly canShowButton = input<boolean>();
  readonly btnText = input<string>('');

  // Input with a default value
  readonly disableForm = input<boolean>(false);

  // New Output API (no longer uses EventEmitter)
  @Output() readonly DeleteClicked = new EventEmitter<void>();

  onClick(): void {
    // The .emit() syntax remains the same
    this.DeleteClicked.emit();
  }
}
